// extracted by mini-css-extract-plugin
export default {"arrowContainer":"Arrows_arrowContainer__LHqeg","leftArrow":"Arrows_leftArrow__ih2Kx","rightArrow":"Arrows_rightArrow__aWL1k"};